export default __webpack_public_path__ + "c49beefd4e78b7f7fd3ec832ece1af68.png";